module.exports = {
    items : [
        {
          src: require('../assets/images/unveiled.gif'),
          title: 'Unveiled',
          desc: 'VR Archery Adventure',
          info: 'My capstone project from AIE. I was the solo programmer on the team and my time was either spent on extending the Unity integration of SteamVR to meet our needs, mechanics programming and optimization for VR.',
          roles: 'Programming and design',
        },
        {
          src: require('../assets/images/bulletsurf.gif'),
          title: 'Bullet Surf',
          desc: 'Laser Riding Platformer',
          info: 'A platformer with weapon that fires a projectile with 2 uses, damage and proving a platform. My focus here was small incremental polish, improving on the feel of the character controller and seeing how far I could push the mechanic.',
          roles: 'Everything',
        },
        {
          src: require('../assets/images/thiefery.gif'),
          title: 'Thiefery',
          desc: 'Move left & right to get the loot',
          info: 'A top down puzzle game where the player can only move left and right. A design with restrictions project where my goal was to program extensible, easy to reuse puzzle pieces that could be repurposed in a pinch.',
          roles: 'Programming and design',
        },
        {
          src: require('../assets/images/combine.gif'),
          title: 'Combine',
          desc: '2048 - Match3 Mashup',
          info: 'A mashup mobile game created during my time at AIE. Place down resources next to each other to combine them and fill the orders up top.',
          roles: 'Everything',
        },
        {
          src: require('../assets/images/connections.gif'),
          title: 'Connections',
          desc: 'Powering up Puzzler',
          info: 'I set out with the goal of making an infinitely playable mobile puzzle game on a 3x3 grid, this was the result. Tap to rotate the tiles and run the power to the other side.',
          roles: 'Everything',
        },
      ]
}